import React, { useEffect, useRef, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { twMerge } from 'tailwind-merge';
export type MenuItem = {
  label: string;
  onSelect: () => void;
  disabled?: boolean;
};
type MenuButtonProps = {
  label: string;
  items: MenuItem[];
  icon: React.ReactNode;
  placement?: 'down' | 'up';
  className?: string;
};
export function MenuButton({
  label,
  items,
  icon,
  placement = 'down',
  className
}: MenuButtonProps) {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (!open) return;
    const onDown = (e: MouseEvent) => !ref.current?.contains(e.target as Node) && setOpen(false);
    const onKey = (e: KeyboardEvent) => e.key === 'Escape' && setOpen(false);
    document.addEventListener('mousedown', onDown);
    document.addEventListener('keydown', onKey);
    return () => {
      document.removeEventListener('mousedown', onDown);
      document.removeEventListener('keydown', onKey);
    };
  }, [open]);
  return <div ref={ref} className="relative" data-id="element-833" data-mp="1j7p3bwbrsz03">
      <button type="button" aria-label={label} aria-haspopup="menu" aria-expanded={open} onClick={e => {
      e.stopPropagation();
      setOpen(o => !o);
    }} className={twMerge('flex h-[22px] w-[22px] items-center justify-center rounded-[5px] text-pf-ink transition-colors duration-150 hover:bg-black/5', className)} data-id="element-834" data-mp="1o8d61f9d34a5">
        
        {icon}
      </button>
      <AnimatePresence data-id="element-835" data-mp="26z49y1aky2h5">
        {open && <motion.ul role="menu" initial={{
        opacity: 0,
        scale: 0.96,
        y: placement === 'up' ? 4 : -4
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.96
      }} transition={{
        duration: 0.14,
        ease: [0.23, 1, 0.32, 1]
      }} style={{
        transformOrigin: placement === 'up' ? 'bottom right' : 'top right'
      }} className={`absolute right-0 z-30 min-w-[180px] rounded-[7px] bg-white py-[4px] shadow-[0_6px_20px_rgba(20,28,38,0.18)] ring-1 ring-black/[0.06] ${placement === 'up' ? 'bottom-full mb-[6px]' : 'top-full mt-[4px]'}`} data-id="element-836" data-mp="26y2w5p26j1vq">
          
            {items.map(item => <li key={item.label} role="none" data-id="element-837" data-mp="2qjlapnrd9e4e">
                <button type="button" role="menuitem" disabled={item.disabled} onClick={e => {
            e.stopPropagation();
            setOpen(false);
            item.onSelect();
          }} className="w-full px-[12px] py-[6px] text-left text-[12px] text-pf-ink transition-colors duration-150 hover:bg-pf-panel disabled:text-pf-faint disabled:hover:bg-white" data-id="element-838" data-mp="2qmh89azay0sb">
              
                  {item.label}
                </button>
              </li>)}
          </motion.ul>}
      </AnimatePresence>
    </div>;
}